













































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {
  DokumentInfo, F_AnalitikaTroskovaOdrzavanja,
  IF_AnalitikaTroskovaOdrzavanja,
  PodsetnikVozila,
  PovezaniDokument
} from "@/services/BackendProxies";
import {formatDate, formatPrice} from "@/utils/formatters";
import dataService from '@/services/data-proxy.service'
import mixin from "vue-i18n/src/mixin";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class AnalitikaTroskovaOdrzavanja extends mixins(ComponentBaseMixin) {
  dokumenta: F_AnalitikaTroskovaOdrzavanja[] = [];
  columns;
  filterVisible = false;
  godina = new Date().getFullYear();
  mesec = '';
  vozilo = '';
  kategorijaVozila = '';
  grupaVozila = '';
  vrstaOdrzavanja = '';
  options = {
      pagination: true,
      search: true,
      showColumns: true,
      showExport: true,
      exportTypes: ['excel'],
      exportDataType: 'all',
  }

  async created() {
    this.columns = [
      {field: 'broj', title: '#'},
      {field: 'datum', title: this.$i18n.t('datum'), formatter: formatDate},
      {field: 'vrstaOdrzavanja', title: this.$i18n.t('p/c')},
      {field: 'tipStavke', title: this.$i18n.t('tipStavke')},
      {field: 'tipDokumenta', title: this.$i18n.t('tip')},
      {field: 'vozilo', title: this.$i18n.t('vozilo')},
      {field: 'kilometraza', title: this.$i18n.t('kilometraza'), align: 'right'},
      {field: 'dobavljac', title: this.$i18n.t('dobavljac')},
      {field: 'opis', title: this.$i18n.t('opis')},
      {field: 'osnovica', title: this.$i18n.t('osnovica'), formatter: formatPrice, align: 'right'},
      {field: 'pdv', title: this.$i18n.t('pdv'), formatter: formatPrice, align: 'right'},
      {field: 'iznos', title: this.$i18n.t('iznos'), formatter: formatPrice, align: 'right'},
      {field: 'iznosZaObracun', title: this.$i18n.t('iznosZaObracun'), formatter: formatPrice, align: 'right'},
    ];
      (<any>this.options).exportOptions = {
          fileName: () => {
              return this.$i18n.t('analitikaTroskovaVozila')
          }
      };
    this.pretrazi();
  }

  toggleFilter() {
    this.filterVisible = !this.filterVisible;
  }

  get postavljenFilter() {
    return this.godina || this.mesec || this.vozilo || this.kategorijaVozila || this.grupaVozila || this.vrstaOdrzavanja;
  }

  @Watch('godina')
  @Watch('mesec')
  @Watch('vozilo')
  @Watch('kategorijaVozila')
  @Watch('grupaVozila')
  @Watch('vrstaOdrzavanja')
  async pretrazi() {
    this.dokumenta = await this.loadData(() => dataService.vratiAnalitikuTroskovaOdrzavanja(
            +this.godina || null,
        +this.mesec || null,
        +this.kategorijaVozila || null,
        +this.grupaVozila || null,
        +this.vozilo || null,
    +this.vrstaOdrzavanja || null))();
  }
}
